import React from 'react';
import styled, {keyframes}from 'styled-components'
import background from '../images/alternativebackground.png'
import Navbar from './Navbar';
import profilepic from '../images/profilepic.jpg'
import { fadeIn } from 'react-animations';

const FadeInAnimation = keyframes`${fadeIn}`;
const Container = styled.div`
width:100%;
background: url(${background});
background-size:cover;                      /* <------ */
background-repeat:no-repeat;
animation: 0.6s ${FadeInAnimation};
font-family:'Barlow';
margin: 0 auto;
color:#EAE1E1;
@media (max-height:880px) {
    width:100%;
    
}

@media (max-width:512px) {
    width:100%;
    height:100%;
}

@media (min-height:900px){
    width:100%;
    min-height:100vh;
}
`


const AboutWrapper = styled.div`
width:100%;
margin:0px auto;
text-align:center;
display:grid;
margin-top:100px;
grid-template-columns: repeat(1,auto);
grid-gap:50px;


@media (max-width:1012px) {
    grid-template-columns: repeat(1,auto);
}

@media (max-width:512px) {
    margin-bottom:50px;
}
`

const Description = styled.div`
width:100%;
text-align:center;
margin:0 auto;
`

const Subtitle = styled.div`
font-family: 'Barlow';
font-style: normal;
font-weight: 300px;
font-size: 30px;
line-height: 36px;
color: #EAE1E1;
width:100%;

@media (min-width:1400px) {
    font-family: 'Barlow';
font-style: normal;
font-weight: 100;
font-size: 42px;
line-height: 1.2;
color: #EAE1E1;
width:80%;
margin: 0 auto;
}

@media (max-width:512px) {
    width:80%;
    height:80%;
    font-size:22px;
    text-align:left;
    margin:20px;
}

@media (max-width:320px) {
    width:80%;
    height:80%;
    font-size:18px;
    text-align:left;
}
`

const Title = styled.div`
font-family: 'Barlow';
font-style: normal;
font-weight: bold;
font-size: 58px;
line-height: 65px;
text-align: center;
letter-spacing: 0.06em;
color: #F2F2F2;
padding:5px;

@media (max-width:800px) {
    font-size:52px;
}
@media (min-width:1400px) {
    font-size:68px;
}

@media (max-width:512px) {
    width:80%;
    height:80%;
    font-size:45px;
    text-align:left;
    margin:20px;
}

@media (max-width:320px) {
    width:80%;
    height:80%;
    font-size:32px;
    text-align:left;
}
`


const Pic = styled.img`
height:200px;
width:210px;
margin-bottom:50px;
border-radius:50%; 

@media (max-width:450px) {
    width:180px;
    height:170px;
}
`

const About = () => {
    return ( <Container>
        <Navbar/>
        <AboutWrapper>
            <Description>
                <Pic src={profilepic}/>
                <Title>
                I’m a developer and designer from Sardinia.
                </Title>
                <Subtitle>
                HTML / CSS / Javascript and React are my mother tongues but I consider myself as a full-stack developer.
                I love to create things, make customers satisfied and learn new things.
                Programming is not my only field of focus, I'm interested in design, social media marketing , UX/UI, technologies, videogames and much more.   
                </Subtitle>
            </Description>
        </AboutWrapper>
    </Container> );
}
 
export default About;